import React, { useState, useEffect } from "react";
import timezones from "./timezones.json";
import moment from "moment";
import momenttz from "moment-timezone";
import Select from "react-select";

export default function App() {
  const [sourceTimezone, setSourceTimezone] = useState(null);
  const [destTimezone, setDestTimezone] = useState(null);
  const [timezoneList, setTimezoneList] = useState([]);
  const [sourceDate, setSourceDate] = useState([
    moment().tz(momenttz.tz.guess())
  ]);
  const [destDate, setDestDate] = useState(moment().tz(momenttz.tz.guess()));

  useEffect(() => {
    const guessTimezone = momenttz.tz.guess();

    if (guessTimezone) {
      setSourceTimezone(guessTimezone);
      setDestTimezone(guessTimezone);
    }
  }, []);

  useEffect(() => {
    const l = [];

    Object.keys(timezones).forEach(val => {
      l.push({
        label: `${timezones[val]} - ${val}`,
        value: val
      });
    });

    setTimezoneList(l);
  }, []);

  const changeDateTime = (type, value) => {
    const currentDateTime = sourceDate[0];
    const v = value.target.value;
    if (type === "date") {
      currentDateTime.set({
        year: v.split("-")[0],
        month: v.split("-")[1] - 1,
        date: v.split("-")[2]
      });
      setSourceDate([currentDateTime]);
      calculateFinalDate(currentDateTime, sourceTimezone, destTimezone);
    }

    if (type === "time") {
      currentDateTime.set({
        hour: v.split(":")[0],
        minute: v.split(":")[1]
      });
      setSourceDate([currentDateTime]);
      calculateFinalDate(currentDateTime, sourceTimezone, destTimezone);
    }
  };

  const calculateFinalDate = (sd, st, dt) => {
    // console.log(
    //   "default source date",
    //   sourceDate[0].format("YYYY-MM-DD HH:mm")
    // );
    // console.log("received source date", sd.format("YYYY-MM-DD HH:mm"));
    const currentDate = moment.tz(sd.format("YYYY-MM-DD HH:mm"), st);
    // console.log("current date with tz", currentDate.format("YYYY-MM-DD HH:mm"));
    const finalDate = currentDate.clone().tz(dt);
    // console.log("final date with tz", finalDate.format("YYYY-MM-DD HH:mm"));
    setDestDate(finalDate);
  };

  return (
    <div
      className="container"
      style={{
        paddingTop: "3em",
        paddingBottom: "10vh",
        paddingRight: "15vw",
        paddingLeft: "15vw"
      }}>
      {/* hero section */}
      <div style={{ textAlign: "center", paddingBottom: "2em" }}>
        <h1 className="display-4">When is the meeting?</h1>
      </div>

      {/* timezone section */}
      <div>
        <h3 style={{ textAlign: "center", paddingTop: 10, paddingBottom: 10 }}>
          The meeting is scheduled at:
        </h3>

        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          <Select
            options={timezoneList}
            value={{
              label: `${timezones[sourceTimezone]} - ${sourceTimezone}`,
              value: sourceTimezone
            }}
            onChange={e => {
              setSourceTimezone(e.value);
              calculateFinalDate(sourceDate[0], e.value, destTimezone);
            }}
          />
        </div>

        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          <div style={{ paddingTop: 10, paddingBottom: 10 }}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    id="source-date"
                    type="date"
                    name="date"
                    defaultValue={sourceDate[0].format("YYYY-MM-DD")}
                    onChange={e => changeDateTime("date", e)}
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <input
                    className="form-control"
                    id="source-time"
                    type="time"
                    name="time"
                    defaultValue={sourceDate[0].format("HH:mm")}
                    onChange={e => changeDateTime("time", e)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <h3 style={{ textAlign: "center", paddingTop: 20, paddingBottom: 10 }}>
          which translates to:
        </h3>

        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          <Select
            options={timezoneList}
            value={{
              label: `${timezones[destTimezone]} - ${destTimezone}`,
              value: destTimezone
            }}
            onChange={e => {
              setDestTimezone(e.value);
              calculateFinalDate(sourceDate[0], sourceTimezone, e.value);
            }}
          />
        </div>

        <h2
          style={{ textAlign: "center", paddingTop: 20, paddingBottom: 20 }}
          className="text-primary">
          {destDate.format("Do MMMM YYYY, h:mm a")}
        </h2>

        <div
          style={{
            marginTop: 30,
            position: "relative",
            bottom: 0
          }}>
          <center>
            <p>
              Made with <span style={{ color: "#e25555" }}>&#9829;</span> by{" "}
              <a href="https://twitter.com/jyotiska_nk">@jyotiska</a>
            </p>
          </center>
        </div>
      </div>
    </div>
  );
}
